import { useQueries, useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

export const getQuadrantViewedStatus = async (params) => {
  const { enrollmentId, chapterId, quadrantId, resourceId } = params;
  var res = null;
  try {
    res = await axios.middleware("/Backend.asmx/BK_Quadrantes_Visualizados", {
      params: { matriculaid: enrollmentId, capituloid: chapterId },
    });
  } catch (e) {}

  const viewData = res?.[0]?.data?.find(
    (quadrant) =>
      quadrant.QUADRANTEID == quadrantId && quadrant.RECURSOID == resourceId,
  );
  return { ...viewData, viewed: !!viewData };
};

export const useQuadrantViewedStatus = ({
  config,
  quadrantId,
  chapterId,
  enrollmentId,
  resourceId = 0,
} = {}) => {
  return useQuery({
    ...config,
    enabled: !!enrollmentId && !!chapterId,
    queryKey: [
      "quadrantViewedStatus",
      { quadrantId, enrollmentId, resourceId },
    ],
    queryFn: () =>
      getQuadrantViewedStatus({
        quadrantId,
        chapterId,
        enrollmentId,
        resourceId,
      }),
  });
};

export const useResourcesViewedStatus = ({
  config,
  chapterId,
  enrollmentId,
  quadrantId,
  resourcesIds,
} = {}) => {
  return useQueries({
    ...config,
    queries: resourcesIds.map((resourceId) => ({
      enabled: !!enrollmentId && !!chapterId,
      queryKey: [
        "quadrantViewedStatus",
        { quadrantId, enrollmentId, resourceId },
      ],
      queryFn: () =>
        getQuadrantViewedStatus({
          quadrantId,
          chapterId,
          enrollmentId,
          resourceId,
        }),
    })),
  });
};
